<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5tCoQ2/tc-custom/9781467461368.jpg?1744431013168" alt="This image is the cover for the book The Gravity of Joy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Gravity of Joy
      </h1>
      <p class="bookDescription body article font2">
        <p><i>“My vocation was supposed to be joy, and I was speaking at funerals.”</i> </p><p>Shortly after being hired by Yale University to study joy, Angela Gorrell got word that a close family member had died by suicide. Less than a month later, she lost her father to a fatal opioid addiction and her nephew, only twenty-two years old, to sudden cardiac arrest. The theoretical joy she was researching at Yale suddenly felt shallow and distant—completely unattainable in the fog of grief she now found herself in. </p><p>But joy was closer at hand than it seemed. As she began volunteering at a women’s maximum-security prison, she met people who suffered extensively yet still showed a tremendous capacity for joy. Talking with these women, many of whom had struggled with addiction and suicidal thoughts themselves, she realized: “Joy doesn’t obliterate grief. . . . Instead, joy has a mysterious capacity to be felt alongside sorrow and even—sometimes most especially—in the midst of suffering.” </p><p>This is the story of Angela’s discovery of an authentic, grounded Christian joy. But even more, it is an invitation for others to seize upon this more resilient joy as a counteragent to the twenty-first-century epidemics of despair, addiction, and suicide—a call to action for communities that yearn to find joy and are willing to “walk together through the shadows” to find it.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Angela Williams Gorrell, Miroslav Volf
      </h2>
      
      <p class="authorDescription body article"><B>Angela Williams Gorrell </B>is a speaker, consultant, and an ordained minister in the Mennonite Church USA with over fourteen years of ministry experience. She has taught at schools including Yale University, Baylor University, and Fuller Seminary.&#160;Her research has been highlighted by the <I>New York Times</I>, NPR, and the<I> Washington Post </I>among others. Her publications include <I>Always On: Practicing Faith in a New Media Landscape</I>,<I> The Gravity of Joy: A Story of Being Lost and Found</I>, and <I>Braving Difficult Decisions: What to Do When You Don&rsquo;t Know What to Do</I>. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25bf09ef